module.exports = __webpack_public_path__ + "img/5.ac3bb9d3.jpg";